import marketing from './marketing';

export const marketingApi = marketing;
